<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>
        {{ lead ? 'Edit Lead' : 'Create New Lead' }}
      </md-dialog-title>

      <FormLead
        v-if="lead"
        @close="showDialog = false" 
        :form="lead" 
        form-type="edit"
      />
      <FormLead 
        v-else
        @close="showDialog = false" 
        form-type="add"
      />

    </md-dialog>

    <md-button 
      v-if="lead"
      class="md-primary"
      @click="showDialog = true"
    >
      <md-icon>edit</md-icon>
      Edit
    </md-button>
    <md-button 
      v-else
      class="md-primary md-raised"
      @click="showDialog = true"
    >
      Add Lead
    </md-button>  
  </div>
</template>

<script>
 import FormLead from '@/components/blocks/forms/Lead'

  export default {
    name: 'CreateLead',
    props: {
      lead: {
        type: Object,
        default: null
      }
    },
    components: {
        FormLead
    },
    data: () => ({
      showDialog: false
    })
  }
</script>
